import { render, staticRenderFns } from "./APIDoc.vue?vue&type=template&id=9b56485a&scoped=true&"
import script from "./APIDoc.vue?vue&type=script&lang=js&"
export * from "./APIDoc.vue?vue&type=script&lang=js&"
import style0 from "./APIDoc.vue?vue&type=style&index=0&id=9b56485a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b56485a",
  null
  
)

export default component.exports